export const dateBounds = () => {
  const max = new Date();
  max.setUTCFullYear(max.getUTCFullYear() + 10);
  return { min: '2000-01-01', max: max.toISOString().slice(0, 10) };
};

export const validPlanningDate = value => {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const parsed = new Date(`${value}T00:00:00Z`);
  const bounds = dateBounds();
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value &&
    value >= bounds.min && value <= bounds.max;
};
